import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";


import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import config from "../../config.js";


const ProgressTracker = ({complaintId}) => {

  const [complaintProgress, setComplaintProgress] = useState({table1Data:[]});

  const complaintsProgress = async () => {
    try{
        const response = await fetch(`${config.BASE_URL_IP}/wob/ComplaintProgress/${complaintId}`, {
        method: "GET", 
        headers: { "Content-Type": "application/json"},
        
      })
      const jsonData = await response.json();
      console.log(jsonData);
      setComplaintProgress(jsonData);
  }
    catch(err){
      console.error("error fetching data",err.message);
    }
  }

  console.log(complaintId);

  useEffect(()=> {
    complaintsProgress();
  },[complaintId]);

  const formattedDate = (dateString) => {
    if (!dateString) return ''; // If dateString is null or undefined, return an empty string
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  };  

  return (
    <Card
      variant="outlined"
      sx={{
        pb: 0,
        borderLeft: "4px solid #1976d2", // Adding a left border
        borderRadius: "8px", // Adding border radius
        boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Adding shadow
        transition: "box-shadow 0.3s", // Adding transition effect
        "&:hover": {
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)", // Changing shadow on hover
        },
      }}
    >
      <CardContent
        sx={{
          pb: "0 !important",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between", // Centering the items horizontally
            mb: 3,
          }}

        >
          <Box>
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "h3.fontSize",
                marginBottom: "0",
              }}
              gutterBottom
            >
              Work Order Progress
            </Typography>
            <Typography
              color="textSecondary"
              variant="body1"
              sx={{
                fontWeight: "400",
                fontSize: "13px",
              }}
            >
              Work Order Id : {complaintId}
            </Typography>
          </Box>
          <Box
            sx={{
              marginLeft: "auto",
            }}
          >
          </Box>
        </Box>
        <Timeline
          sx={{
            p: 0,
          }}
        >
          {complaintProgress.table1Data.map((activity) => (
            <>
            <TimelineItem key={activity.time}>
              <TimelineOppositeContent
                sx={{
                  fontSize: "14px",
                  fontWeight: "700",
                  flex: "1",
                }}
              >
                {'Work order Raised'}
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot
                  variant="outlined"
                  sx={{
                    borderColor: "success.main",
                  }}
                />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent
                color="text.primary"
                sx={{
                  fontSize: "14px",
                }}
              >
                {formattedDate(activity.complaint_raise_date)}
              </TimelineContent>
              
            </TimelineItem>

            <TimelineItem key={activity.time}>
            <TimelineOppositeContent
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                flex: "1",
              }}
            >
              {"Approved By HOD"}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                variant="outlined"
                sx={{
                  borderColor: "success.main",
                }}
              />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              color="text.primary"
              sx={{
                fontSize: "14px",
              }}
            >
              {formattedDate(activity.approved_by_hod_date)}
            </TimelineContent>

            </TimelineItem>

            <TimelineItem key={activity.time}>
            <TimelineOppositeContent
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                flex: "1",
              }}
            >
              {'Approved By AO'}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                variant="outlined"
                sx={{
                  borderColor: "success.main",
                }}
              />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              color="text.primary"
              sx={{
                fontSize: "14px",
              }}
            >
              {formattedDate(activity.approved_by_ao_date)}
            </TimelineContent>

            </TimelineItem>

            <TimelineItem key={activity.time}>
            <TimelineOppositeContent
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                flex: "1",
              }}
            >
              {'Approved By Director'}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                variant="outlined"
                sx={{
                  borderColor: "success.main",
                }}
              />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              color="text.primary"
              sx={{
                fontSize: "14px",
              }}
            >
              {formattedDate(activity.approved_by_director_date)}
            </TimelineContent>

            </TimelineItem>
            
            

            <TimelineItem key={activity.time}>
            <TimelineOppositeContent
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                flex: "1",
              }}
            >
              {`Work Assigned` }
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                variant="outlined"
                sx={{
                  borderColor: "success.main",
                }}
              />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent
              color="text.primary"
              sx={{
                fontSize: "14px",
              }}
            >
              {formattedDate(activity.work_assigned_date)}
            </TimelineContent>

            </TimelineItem>

            
            <TimelineItem key={activity.time}>
            <TimelineOppositeContent
              sx={{
                fontSize: "14px",
                fontWeight: "700",
                flex: "1",
              }}
            >
              {'Work Completed'}
            </TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot
                variant="outlined"
                sx={{
                  borderColor: "success.main",
                }}
              />
            </TimelineSeparator>
            <TimelineContent
              color="text.primary"
              sx={{
                fontSize: "14px",
              }}
            >
              {formattedDate(activity.work_completion_date)}
            </TimelineContent>

            </TimelineItem>
            </>
          ))}
        </Timeline>
      </CardContent>
    </Card>
  );
};

export default ProgressTracker;